import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface AppToast {
  id: number;
  type: ToastType;
  title: string;
  message?: string;
  duration?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly itemsSubject = new BehaviorSubject<AppToast[]>([]);
  readonly items$ = this.itemsSubject.asObservable();
  private seq = 1;

  success(title: string, message?: string, duration = 3500): void {
    this.show('success', title, message, duration);
  }

  error(title: string, message?: string, duration = 5500): void {
    this.show('error', title, message, duration);
  }

  info(title: string, message?: string, duration = 4200): void {
    this.show('info', title, message, duration);
  }

  warning(title: string, message?: string, duration = 5000): void {
    this.show('warning', title, message, duration);
  }

  show(type: ToastType, title: string, message?: string, duration = 4000): void {
    const toast: AppToast = {
      id: this.seq++,
      type,
      title,
      message,
      duration,
    };

    this.itemsSubject.next([toast, ...this.itemsSubject.value].slice(0, 5));

    if (duration > 0) {
      window.setTimeout(() => this.remove(toast.id), duration);
    }
  }

  remove(id: number): void {
    this.itemsSubject.next(this.itemsSubject.value.filter((item) => item.id !== id));
  }

  clear(): void {
    this.itemsSubject.next([]);
  }
}
